module.exports = __webpack_public_path__ + "static/media/2.3c58aa45.png";